<template>
  <q-btn
    flat
    round
    dense
    size="20px"
    class="q-ml-sm no-shadow"
    :class="{ 'animated animate-bounce': bounce }"
    color="grey-5"
    no-ripple
    icon="notifications"
  >
    <q-chip
      v-if="unreadNotificationsLength"
      color="negative"
      floating
      small
      class="q-caption"
    >
      {{ unreadNotificationsLength }}
    </q-chip>
    <q-popover style="width: 300px">
      <q-list no-border class="q-py-none">
        <q-list-header style="border-bottom: 1px solid #e0e0e0">Nachrichten</q-list-header>
        <q-item v-if="!notifications.length">
          <q-item-main class="text-italic text-center">
            <small>Keine Nachrichten</small>
          </q-item-main>
        </q-item>
      </q-list>
      <q-list no-border highlight separator class="q-pt-none">
        <q-item
          v-for="notif of notifications"
          :key="notif.id"
          :class="{ unread: notif.unread }"
          :link="!!notif.action"
          v-close-overlay
          @mouseover.native="notif.unread && notif.onRead && notif.onRead(); notif.unread = false;"
          @click.native="notif.action && notif.action()"
        >
          <q-item-main>
            <q-item-tile label>{{ notif.title }}</q-item-tile>
            <q-item-tile sublabel>{{ notif.message }}</q-item-tile>
          </q-item-main>
        </q-item>
      </q-list>
    </q-popover>
  </q-btn>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NotificationButton',

  data: () => ({
    // isOpen: false,
    bounce: false,
    notifications: [],
  }),

  computed: {
    ...mapState('auth', ['currentUser']),

    unreadNotificationsLength() {
      return this.notifications.filter(n => n.unread).length;
    },
  },

  watch: {
    unreadNotificationsLength(newVal, oldVal) {
      if (newVal > oldVal) this.triggerBounce();
    },
  },

  async mounted() {
    const twoFaSeen = !!localStorage['2fa-notif-seen'];
    if (!twoFaSeen) await new Promise(resolve => setTimeout(resolve, 25000));

    if (this.currentUser.two_fa_status !== 'active') {
      this.notifications.unshift({
        id: 1,
        unread: !twoFaSeen,
        title: 'Zwei-Faktor-Authentifizierung nicht aktiviert',
        message: 'Erhöhen Sie die Sicherheit Ihres Kontos, indem Sie jetzt die Zwei-Faktor-Authentifizierung aktivieren.',
        onRead: () => {
          localStorage['2fa-notif-seen'] = true;
        },
        action: () => {
          this.$router.push('/profile-settings#manage-2factor');
        },
      });
    }
  },

  methods: {
    /*
    setDrawer() {
      const isOpen = this.$store.state.userSetting.notificationDrawerOpen;
      this.$store.commit('userSetting/SET_LOCAL', { key: 'notificationDrawerOpen', value: !isOpen });
    },
    */
    async triggerBounce() {
      this.bounce = true;
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.bounce = false;
    },
  },

};
</script>
<style scoped lang="stylus">
>>> .q-chip-floating {
  border-radius: 50%;
  top: 0.4em;
  right: 0.9em;
}
.unread {
  background-color: rgba(0, 0, 100, 0.05);
}
</style>
